import api from '@/apis'
import { createLatestOnly } from '@/utils/latestOnly'

// One counter each: these are independent lists that must not supersede one another.
const teams_request = createLatestOnly()
const windows_request = createLatestOnly()
const users_request = createLatestOnly()

export default {
  state: {
    teams: [],
    windows: [],
    users: [],
    queues: []
  },
  mutations: {
    SET_GENERAL_TEAMS(state, payload) {
      state.teams = payload
    },
    SET_GENERAL_WINDOWS(state, payload) {
      payload.unshift({ window_id: null, name: 'All Counter' })
      state.windows = payload
    },
    SET_GENERAL_USERS(state, payload) {
      payload.unshift({ user_id: null, firstname: 'All', lastname: 'Staffs' })
      state.users = payload
    },
    SET_GENERAL_QUEUES(state, payload) {
      state.queues = payload
    }
  },
  actions: {
    initTicketingSystem({ dispatch }) {
      dispatch('fetchTeamList')
      dispatch('fetchWindowList')
      dispatch('fetchUserList')
      dispatch('fetchServiceTypeList')
      console.log('[System] Initializing...')
    },
    async fetchTeamList({ commit }) {
      const isLatest = teams_request()
      try {
        const response = await api.getTeams()
        // A newer request of this kind owns the view now — see utils/latestOnly.js.
        if (!isLatest()) return
        if (response.data.success) {
          commit('SET_GENERAL_TEAMS', response.data.data)
        } else {
          throw Error(response.data.message)
        }
      } catch (error) {
        if (!isLatest()) return
        console.log('Init Team List Failed - ', error.message)
      }
    },
    async fetchWindowList({ commit }) {
      const isLatest = windows_request()
      try {
        const response = await api.getWindows()
        // A newer request of this kind owns the view now — see utils/latestOnly.js.
        if (!isLatest()) return
        if (response.data.success) {
          commit('SET_GENERAL_WINDOWS', response.data.data)
        } else {
          throw Error(response.data.message)
        }
      } catch (error) {
        if (!isLatest()) return
        console.log('Init Window List Failed - ', error.message)
      }
    },
    async fetchUserList({ commit }) {
      const isLatest = users_request()
      try {
        const response = await api.getUsers()
        // A newer request of this kind owns the view now — see utils/latestOnly.js.
        if (!isLatest()) return
        if (response.data.success) {
          commit('SET_GENERAL_USERS', response.data.data)
        } else {
          throw Error(response.data.message)
        }
      } catch (error) {
        if (!isLatest()) return
        console.log('Init User List Failed - ', error.message)
      }
    }
  }
}
